<div class="header-mainInfo">
  <div style="line-height: 1.2; padding-top: 2px;">
    {{unidad.nombre}} <br>
    <small style="font-weight: normal" class="opacity-medium">
      {{unidad.materias.length > 0 ? unidad.materias.length.toString() : 'Sin'}} materia{{unidad.materias.length
    != 1 ? 's' : ''}}
      <button class="md-14" type="button" mat-icon-button [matMenuTriggerFor]="menuMaterias">
        <mat-icon *ngIf="!menuMaterias.menuOpen">arrow_drop_down</mat-icon>
        <mat-icon *ngIf="menuMaterias.menuOpen">arrow_drop_up</mat-icon>
      </button>
    </small>
    <mat-menu #menuMaterias="matMenu" yPosition="below" [overlapTrigger]="false">
      <ng-container *ngFor="let materia of unidad.materias">
        <button mat-menu-item [matMenuTriggerFor]="sub_menu">{{materia.nombreCompleto}}</button>
        <mat-menu #sub_menu="matMenu">
          <a [routerLink]="['/', 'informes', 'mcp', materia.id]">
            <button mat-menu-item>
              Informes
            </button>
          </a>
          <a href="{{env.miUrl}}/Academia/Materia/Curso/{{materia.id}}/{{materia.periodoID}}" target="_blank">
            <button mat-menu-item>
              Ver materia
            </button>
          </a>
          <a [routerLink]="['/', 'estudio', 'retroalimentacion', 'dashboard', 'materia', materia.id]">
            <button mat-menu-item>
              Ver estado de retroalimentación
            </button>
          </a>
          <a [routerLink]="['/', 'asistencia', 'materia', materia.id]">
            <button mat-menu-item>
              Tomar asistencia
            </button>
          </a>
        </mat-menu>
      </ng-container>
    </mat-menu>
    <span style="opacity: 0.6;">
            <small>{{unidad.clasesEsperadas}} clases del </small>
            <small>{{unidad.fechaInicia | date: 'd MMM yyyy'}}</small>
            <small>&nbsp;al&nbsp;</small>
            <small>{{unidad.fechaFin | date: 'd MMM yyyy'}}</small>
            <span class="">&nbsp;&nbsp;</span>
        </span>
    <span *ngIf="unidad.alumnosIEP.length > 0">
            <small class="IEP">IEP</small>
        </span>
  </div>
  <span class="spacer"></span>
  <!--
  <div>
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      {{idiomaDisplay}}
    </button>
    <mat-menu #menu="matMenu">
      <div *ngIf="idiomas$ | async as idiomas" >
        <button *ngFor="let idioma of idiomas" (click)="cambiarIdioma(idioma.value)" mat-menu-item>
          {{idioma.value | i18nSelect: {'es': 'Español', 'en': 'English', 'fr': 'Français', 'de': 'Deutsche' } }}
        </button>
      </div>
    </mat-menu>
    <button type="button" mat-icon-button (click)="verComentarios()">
      <mat-icon>comment</mat-icon>
      <sup class="notificaciones-capsule"
           *ngIf="unidad.comentariosNuevos > 0">{{unidad.comentariosNuevos}}
      </sup>
    </button>
    <button type="button" mat-icon-button (click)="marcarFavorita()">
      <mat-icon *ngIf="unidad.isFavorito">bookmark</mat-icon>
      <mat-icon *ngIf="!unidad.isFavorito">bookmark_border</mat-icon>
    </button>
    <button type="button" mat-icon-button [matMenuTriggerFor]="menuUnidad">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menuUnidad="matMenu">
      <a href="{{env.miUrl}}/Estudio/Unidades/Unidad/{{unidad.id}}/Duplicar" target="_blank">
        <button mat-menu-item>
          <mat-icon>content_copy</mat-icon>
          <span>Duplicar</span>
        </button>
      </a>
      <button mat-menu-item (click)="setEstadoSuscripcion(!unidad.isNotificar)">
        <ng-container>
          <mat-icon>{{unidad.isNotificar ? 'notifications_off' : 'notifications_active'}}</mat-icon>
          <span>{{unidad.isNotificar ? 'Desactivar notificaciones' : 'Activar notificaciones'}}</span>
        </ng-container>
      </button>
      <button mat-menu-item disabled>
        <mat-icon>check</mat-icon>
        <span>Evaluar</span>
        </button>
      </mat-menu>
    </div>
  -->
</div>
